<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="detailmodel2 clearfix plr30 ptb10">
        <h2 class="title pt40">{{ detail.title }} <el-button type="primary" icon="el-icon-link" v-if="detail.link !== undefined && detail.link !== ''" @click="gohref(detail.link)"></el-button></h2>
        <ul class="ul2 mt30 mb20 clearfix">
          <li v-show="detail.openTime !== undefined && detail.openTime !== ''"><label><i class="icon icon1"></i>开放时间：</label><span>{{ detail.openTime }}</span></li>
          <li v-show="detail.area !== undefined && detail.area !== ''"><label><i class="icon icon2"></i>面积：</label><span>{{ detail.area }}</span></li>
          <li v-show="detail.phone !== undefined && detail.phone !== ''"><label><i class="icon icon3"></i>联系电话：</label><span>{{ detail.phone }}</span></li>
          <li v-show="detail.address !== undefined && detail.address !== ''"><label><i class="icon icon4"></i>地址：</label><span>{{ detail.address }}</span></li>
        </ul>
        <div class="imagetop mt50">
          <swiper class="swipertop" ref="swipertop" :options="swiperOptiontop">
            <swiper-slide class="swiper-slide" v-for="(banner, index) in detail.attachImage" :key="index">
              <img :src="banner">
            </swiper-slide>
          </swiper>
        </div>
        <div class="imagebottom mb50">
          <swiper class="swiperbottom" ref="swiperbottom" :options="swiperOptionbottom">
            <swiper-slide class="swiper-slide" v-for="(banner, index) in detail.attachImage" :key="index">
              <img :src="banner">
            </swiper-slide>
          </swiper>
          <div class="swiper-button-next swiper-button-white"></div>
          <div class="swiper-button-prev swiper-button-white"></div>
        </div>
        <div class="contentbox mtb2 min-height300" v-html="detail.content">
        </div>
        <comment v-if="detail" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        <right-sidebar
          @pvcount="pvcount"
          :comment-count="commentTotal"
          :comment-gotop="commentOffsettop"
          :comment-show="isCommentshow"
          :title="detail.title"
          :image="getImage(detail.image)"
          :url="this.$route.fullPath"
          ref="rightSidebar"></right-sidebar>
        <go-top></go-top>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/validate'
import { getPavilionDetail } from '@/api/pavilion/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import pv from '@/components/amount/pv'
import crumbs from '@/components/crumbs/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'paviliondetail',
  meta: {
    showHeader: true
  },
  components: {
    Comment,
    RightSidebar,
    goTop,
    pv,
    crumbs,
    swiper,
    swiperSlide
  },
  data () {
    return {
      detail: '',
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      swiperOptiontop: {
      },
      swiperOptionbottom: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.imagebottom .swiper-button-next',
          prevEl: '.imagebottom .swiper-button-prev'
        }
      }
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    gohref (val) {
      window.open(val)
    },
    /* 获取信息详情 */
    getDetail () {
      getPavilionDetail(this.$route.query.id).then((res) => {
        if (res.data.status === 200) {
          let imageArr = []
          this.detail = res.data.data
          if (this.detail.attachImage !== undefined && this.detail.attachImage !== '') {
            if (this.detail.attachImage.indexOf('|') > -1) {
              imageArr = this.detail.attachImage.split('|')
            } else {
              imageArr.push(this.detail.attachImage)
            }
          } else {
            imageArr.push(require('@/assets/common/images/default.png'))
          }
          this.detail.attachImage = imageArr
          this.detail.createTime = timeFormat(this.detail.createTime, 'yymmddhhmm')
          this.$nextTick(() => {
            const swiperTop = this.$refs.swipertop.swiper
            const swiperThumbs = this.$refs.swiperbottom.swiper
            swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
          })
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detailmodel2{
  .swiper-container {
  }
  .imagetop{
    background: #f7f7f7;
    padding: 30px 0;
    .swiper-slide{
      height: 480px;
      img{
        width: auto;
        height: 100%;
        margin: 0 auto;
        display: block;
      }
    }
  }
  .imagebottom {
    background: #eee;
    height: 20%!important;
    box-sizing: border-box;
    padding: 10px 0;
    .swiper-slide{
      width: 25%;
      height: 150px;
      opacity: 0.4;
      img{
        width: 100%;
        min-height: 100%;
      }
    }
    .swiper-slide-active{
      opacity: 1;
    }
    .swiper-button-prev,
    .swiper-button-next{
      width: 36px;
      height: 54px;
      top: 51%;
      background-color: rgba(0,0,0,0.5);
      background-size: 20px 20px;
      &:after{
        font-size: 30px;
      }
    }
    .swiper-button-prev{
      left: 30px;
    }
    .swiper-button-next{
      right: 30px;
    }
  }
  .title{
    text-align: left;
    padding-right: 5%;
    position: relative;
    /deep/ .el-button{
      position: absolute;
      background: #4c9be5;
      border-radius: 10px;
      top: 40px;
      right: 0;
      .el-icon-link:before{
        font-size: 20px;
      }
    }
  }
  .ul2{
    li{
      line-height: 44px;
      float: left;
      width: 46%;
      margin: 0 4% 0 0;
      border-bottom: dashed 1px #eee;
      font-size: 16px;
      i{
        display: inline-block;
        padding: 0 0 0 24px;
        background: url('../../assets/common/icon/icon-group3.png') no-repeat;
        width: 24px;
        height: 24px;
        position: relative;
        top: 6px;
        margin: 0 5px 0 0;
        &.icon1{
          background-position: -168px 0;
        }
        &.icon2{
          background-position: -48px 0;
        }
        &.icon3{
          background-position: 0 0;
        }
        &.icon4{
          background-position: -72px 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/pavilion/detail.vue